// src/components/Auth/EmployeePOSLogin.jsx
import React, { useState } from 'react';

const EmployeePOSLogin = ({ onEmployeeLogin, onLogout }) => {
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handlePinInput = (digit) => {
    if (pin.length < 4) {
      setPin(prev => prev + digit);
      setError('');
    }
  };

  const handleClear = () => {
    setPin('');
    setError('');
  };

  const handleSubmit = async () => {
    if (pin.length !== 4) {
      setError('Ingresa tu PIN de 4 dígitos');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const res = await fetch('/api/employee_login.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ pin })
      });

      const data = await res.json();

      if (data.success) {
        // Guardar sesión de empleado en localStorage
        localStorage.setItem('employeeSession', JSON.stringify(data.employee));
        onEmployeeLogin(data.employee);
      } else {
        setError(data.message || 'PIN incorrecto');
        setPin('');
      }

    } catch (err) {
      setError('Error de conexión');
      setPin('');
    } finally {
      setLoading(false);
    }
  };

  // Auto-submit cuando se completan 4 dígitos
  React.useEffect(() => {
    if (pin.length === 4) {
      handleSubmit();
    }
  }, [pin]);

  const digits = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '', '0', '⌫'];

  return (
    <div className="min-h-screen bg-[#F9EFD7] flex flex-col items-center justify-center px-4">

      <div className="w-full max-w-sm">

        {/* Logo */}
        <div className="flex justify-center mb-8">
          <img
            src="https://4tsix0yujj.ufs.sh/f/2vMRHqOYUHc0UPtKdi4lpN4OwGAX7ky90Ihqt2Z5MKWHdTfQ"
            alt="Logo"
            className="h-16"
          />
        </div>

        <h2 className="text-2xl font-bold text-[#3F1907] text-center mb-2">
          Acceso al POS
        </h2>
        <p className="text-sm text-gray-500 text-center mb-8">
          Ingresa tu PIN de 4 dígitos
        </p>

        {/* Indicador de PIN */}
        <div className="flex justify-center space-x-4 mb-6">
          {[0, 1, 2, 3].map(i => (
            <div
              key={i}
              className={`w-4 h-4 rounded-full border-2 transition-all duration-150 ${
                pin.length > i
                  ? 'bg-[#3F1907] border-[#3F1907]'
                  : 'bg-transparent border-[#58735A]'
              }`}
            />
          ))}
        </div>

        {/* Error */}
        {error && (
          <div className="mb-4 p-3 bg-red-100 text-red-700 rounded-md text-sm text-center">
            {error}
          </div>
        )}

        {/* Teclado numérico */}
        <div className="grid grid-cols-3 gap-3 mb-6">
          {digits.map((digit, idx) => {
            if (digit === '') {
              return <div key={idx} />;
            }
            if (digit === '⌫') {
              return (
                <button
                  key={idx}
                  onClick={() => setPin(prev => prev.slice(0, -1))}
                  className="h-16 bg-gray-200 hover:bg-gray-300 text-[#3F1907] text-xl font-bold rounded-xl transition duration-150 active:scale-95"
                >
                  {digit}
                </button>
              );
            }
            return (
              <button
                key={idx}
                onClick={() => handlePinInput(digit)}
                disabled={loading}
                className="h-16 bg-white hover:bg-[#58735A] hover:text-[#F9EFD7] text-[#3F1907] text-xl font-bold rounded-xl shadow transition duration-150 active:scale-95 disabled:opacity-50"
              >
                {digit}
              </button>
            );
          })}
        </div>

        {loading && (
          <p className="text-center text-[#58735A] text-sm mb-4">Verificando...</p>
        )}

        {/* Botón limpiar */}
        <button
          onClick={handleClear}
          className="w-full py-2 text-sm text-gray-500 hover:text-[#3F1907] transition duration-150"
        >
          Limpiar
        </button>

        {/* Cerrar sesión del sistema */}
        <div className="mt-6 text-center">
          <button
            onClick={onLogout}
            className="text-xs text-gray-400 hover:text-[#3F1907] transition duration-150"
          >
            Cerrar sesión del sistema
          </button>
        </div>

      </div>
    </div>
  );
};

export default EmployeePOSLogin;